// extracted by mini-css-extract-plugin
export default {"container":"Lq-z","brandName":"Mq-z","productName":"Nq-z","productNamePdpEnhancements":"Oq-z","breakLongProductName":"Pq-z"};